module.exports = __webpack_public_path__ + "static/media/logo_small.a4b79e3d.png";